/** An array defining the available page size options for pagination. */
export const pageSizeOptions = [10, 20, 30];